import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { CustomerService } from 'src/app/core/services/customer.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { ProductCode } from 'src/app/model/industry';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProductRelease } from 'src/app/model/ProductRelease';
@Component({
  selector: 'ms-product-viewer',
  templateUrl: './product-viewer.component.html',
  styleUrls: ['./product-viewer.component.scss']
})
export class ProductViewerComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productDownloadService: ProductDownloadService,
    public loadingService: LoadingService,
    public navigateService: NavigateService,
    public customerService: CustomerService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
    };
  }

  productDto: ProductDto;

  internetRole: string;
  isLoading: boolean = false;

  principalProductRelease: ProductRelease;

  isPlatinumPartner: boolean = false;

  async ngOnInit() {
    this.isLoading = true

    if(!this.navigateService.getLocalStorageData<ProductDto>('productDto'))
      this.router.navigate(['/products-download/products-download'])
    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');

    try {
      let principalProductRes = await this.productDownloadService.getProductReleases(this.productDto.Family, this.productDto.ProductCode, this.productDto.ReleaseNr, null, null, this.productDto.Family == this.productDto.ProductCode);
      if(!principalProductRes.Result || !principalProductRes.Content) throw new Error();
      this.principalProductRelease = principalProductRes.Content.find(pr => pr.ProductCode == this.productDto.ProductCode);
      this.productDto.ReleaseNr = this.principalProductRelease.ReleaseNr;
      this.productDto.Date = this.principalProductRelease.PublicationDate;
      this.productDto.Description = this.principalProductRelease.Description
      this.productDownloadService.setPlatinumPartner(this.getProductCodeZucchetti(this.productDto.Family));
      this.navigateService.setLocalStorageData('productDto', JSON.stringify(this.productDto))
      this.isLoading = false
    }
    catch (err){
      this.isLoading = false
    }
  }

  getProductCodeZucchetti(pc: string) {
    switch (pc) {
        case "MAGOWEB":
            return ProductCode.MAGOWEB;
        case "MAGOCLD":
            return ProductCode.MAGOCLD;
        case "MAGO4":
        case "MAGO.NET":
          return ProductCode.MAGO4;
    }
  }

}
